import * as React from 'react';
import { colors } from '../../../index';

const IconSecurity = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 12 14",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.68 2.435L6.189.045a.54.54 0 00-.433 0L.32 2.437a.531.531 0 00-.32.485v4.197c0 1.586.632 3.207 1.734 4.448a6.258 6.258 0 001.9 1.468A5.29 5.29 0 006 13.6a5.46 5.46 0 003.208-1.058.528.528 0 00.118-.742.539.539 0 00-.748-.117A4.391 4.391 0 016 12.538c-2.58 0-4.929-2.583-4.929-5.42v-3.85l4.903-2.156 4.955 2.157v3.85c0 .978-.284 1.968-.82 2.863a.529.529 0 00.187.728c.254.15.583.067.734-.185.635-1.06.97-2.237.97-3.406V2.922a.531.531 0 00-.32-.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.207L5.23 8.481 3.327 6.637a.545.545 0 00-.774.015.555.555 0 00.015.78l1.93 1.87.002.003a1.051 1.051 0 00.776.294 1.053 1.053 0 00.77-.38L9.48 4.896a.555.555 0 00-.085-.775.545.545 0 00-.77.086z"
  })));
};

export default IconSecurity;